import React, { useEffect, useState } from "react";
import AdminNavbar from "../../components/partial/AdminNavbar";
import { useDispatch, useSelector } from "react-redux";
import {
  addDownload,
  deleteDownload,
  getDownloadData,
} from "../../store/download/reducer";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { AddDownloads } from "../../components/showmodal/dowmload/AddDownloads";
import { ShowDownload } from "../../components/showmodal/dowmload/ShowDownload";
import Button from "../../components/common/Button";

const Download = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const downloadData = useSelector(
    (state) => state.downloadReducer.downloadData,
  );

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      dispatch(deleteDownload(id)).then(() => {
        dispatch(getDownloadData);
      });
    }
  };

  const handleEdit = (title, id) => {
    navigate(`/nvm-admin/download/edit/${encodeURIComponent(title)}`, {
      state: { id },
    });
  };

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setViewModal(true);
  };

  useEffect(() => {
    getDownloadData(dispatch);
  }, []);

  return (
    <div className="flex flex-col md:flex-row md:items-center bg-gray-100 min-h-screen">
      {/* Sidebar */}
      <div className="lg:w-1/4 bg-white shadow-md">
        <AdminNavbar />
      </div>

      {/* Main Content */}
      <div className="flex-1 p-6 md:flex-row">
        <h1 className="text-3xl font-bold text-[#1e81b0] mb-6 text-center">
          File Upload
        </h1>
        <div className="flex items-center justify-center">
          {/* Add File Button */}
          <Button
            type="primary"
            onClick={handleOpenModal}
            className="px-6 py-3"
          >
            Add File
          </Button>
        </div>

        {/* Modal for Adding File */}
        <AddDownloads modalOpen={modalOpen} setModalOpen={setModalOpen} />

        {/* Modal for Showing File Details */}
        {viewModal && (
          <ShowDownload
            modalOpen={viewModal}
            setModalOpen={setViewModal}
            folderData={selectedFile} // Pass the selected file's data to the modal
          />
        )}

        {/* Uploaded Files */}
        <div className="mt-8 w-full px-3 lg:px-16">
          <h2 className="text-2xl font-semibold mb-4">Uploaded Files</h2>
          {downloadData.length > 0 ? (
            <div className="space-y-4">
              {downloadData.map((file, index) => (
                <div
                  key={index}
                  className=" bg-gray-50 border px-4  rounded-md shadow-sm flex justify-between items-center relative"
                >
                  <div
                    className="w-full py-2  cursor-pointer"
                    key={index}
                    onClick={() => handleFileClick(file)}
                  >
                    <h3 className="text-lg font-bold">{file.title}</h3>
                    <p className="text-gray-600">{file.description}</p>
                    <p>{new Date(file.createdAt).toLocaleDateString()}</p>
                  </div>
                  <div
                    className="flex items-center space-x-4 relative"
                    onMouseEnter={() => setOpenEdit(file._id)}
                    onMouseLeave={() => setOpenEdit(null)}
                  >
                    <div className="">
                      <BsThreeDotsVertical
                        size={20}
                        className="cursor-pointer"
                        onClick={() =>
                          setOpenEdit(openEdit === index ? null : index)
                        }
                      />
                      {openEdit === index && (
                        <div
                          className="absolute right-0 bg-white border rounded-md shadow-lg py-2 w-32 z-50"
                          style={{ zIndex: 50 }}
                        >
                          <button
                            onClick={() => handleEdit(file.title, file._id)}
                            className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(file._id)}
                            className="block w-full px-4 py-2 text-left text-red-600 hover:bg-red-100"
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-600">No files uploaded yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Download;
